import "./services-cards.scss";

import AnimatedVisualSwap from "@frontend/js/Components/Shared/Animation/AnimatedVisualSwap";
import DefaultServiceImage from "@frontend/images/DefaultServiceImage";
import { Link } from "@inertiajs/react";

export default function ServicesCards({
    cards = [],
    hideLabel = false,
    getHref = null,
}) {
    const cardsList = cards?.data || cards || [];

    return (
        <>
            {cardsList.map((card, index) => {
                const href =
                    typeof getHref === "function"
                        ? getHref(card, index)
                        : card.href;
                const Wrapper = href ? Link : "div";
                const wrapperProps = href
                    ? { href, className: "servicesCards__card__link" }
                    : { className: "servicesCards__card__link" };

                return (
                    <div
                        key={card.id || card.slug || index}
                        className="servicesCards__card"
                    >
                        <Wrapper {...wrapperProps}>
                            {card.animation_id ? (
                                <AnimatedVisualSwap
                                    animationId={card.animation_id}
                                />
                            ) : (
                                <div
                                    className="servicesCards__card__fallback"
                                    aria-hidden="true"
                                >
                                    <DefaultServiceImage />
                                </div>
                            )}
                            {!hideLabel && (
                                <span className="servicesCards__card__label">
                                    {card.servicesCount || card.label}
                                </span>
                            )}
                            <h3 className="servicesCards__card__title">
                                {card.title}
                            </h3>
                        </Wrapper>
                    </div>
                );
            })}
        </>
    );
}
